import { useCallback, useEffect, useState } from "react";
import { getOS } from "../../../utils/UserOS";
import { setOpenForCommentData } from "./helpers/OpenForCommentTableHelper";
import { draftAPI, filingAPI } from "../../../utils/api";
import { Filing } from "../../../utils/model/Filing";

export const useOpenForCommentController = () => {
  const os = getOS();
  const platform = os !== "iOS" && os !== "Android" ? "desktop" : "mobile";

  const [tableData, setTableData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const loadData = useCallback(async () => {
    let filings = await filingAPI.getPublicProposedRuleFilings();
    if (filings.length > 0) {
      const data = await setOpenForCommentData(filings);
      setTableData(data);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    loadData();
  }, [loadData]);

  return {
    // variables
    platform,
    tableData,
    loading,
  };
};
